import { PICS_URL } from 'api';
import AddOrLinkButton from 'components/AddOrLinkButton';
import InputSelect from 'components/InputSelect';
import Counter2 from 'components/counter2';
import CalculatorPackichQuote from 'components/quote/packich_quote';
import { useStores } from 'hooks/useStores';
import { format_price } from 'js/utils';
import React, { useEffect, useRef, useState } from "react";
import Price from './components/Price';

const Termofilm = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFetchedAdd, setIsFetchedAdd] = useState(false);
  const [items, setItems] = useState({});
  const [fetch, setFetch] = useState(1);
  const [formFactor, setFormFactor] = useState(1);
  const [defaultFormFactor, setDefaultFormFactor] = useState(1);
  const [width, setWidth] = useState(1);
  const [defaultWidth, setDefaultWidth] = useState(1);
  const [length, setLength] = useState(1);
  const [defaultLength, setDefaultLength] = useState(1);
  const [thickness, setThickness] = useState(1);
  const [defaultThickness, setDefaultThickness] = useState(1);
  const [count, setCount] = useState(1);

  const { api, cartStore } = useStores();

  const { addCartItem } = cartStore

  useEffect(() => {
    setIsLoaded(false);
    setIsLoadedPVC(false);
    setIsLoadedPVD(false);

    api.catalog
      .getTermoFilmPofCalc({
        form_factor: formFactor,
        width: width,
        length: length,
        thickness: thickness,
      })
      .then((response) => {
        setItems(response);
        for (let item of response.form_factor) {
          if (item.is_active === true) {
            setDefaultFormFactor(item);
          }
        }
        for (let item of response.width) {
          if (item.is_active === true) {
            setDefaultWidth(item);
          }
        }
        for (let item of response.length) {
          if (item.is_active === true) {
            setDefaultLength(item);
          }
        }
        for (let item of response.thickness) {
          if (item.is_active === true) {
            setDefaultThickness(item);
          }
        }
        setIsLoaded(true);
      });
  }, [fetch]);

  const formFactorHandler = (value) => {
    setFormFactor(value.value);
    if (isLoaded) {
      setFetch(fetch + 1);
    }
    if (isLoadedPVC) {
      setFetchPVC(fetchPVC + 1);
    }
    if (isLoadedPVD) {
      setFetchPVD(fetchPVD + 1);
    }
    restartButton();
  };

  const widthHandler = (value) => {
    setWidth(value.value);
    if (isLoaded) {
      setFetch(fetch + 1);
    }
    if (isLoadedPVC) {
      setFetchPVC(fetchPVC + 1);
    }
    if (isLoadedPVD) {
      setFetchPVD(fetchPVD + 1);
    }
    restartButton();
  };

  const lengthHandler = (value) => {
    setLength(value.value);
    if (isLoaded) {
      setFetch(fetch + 1);
    }
    if (isLoadedPVC) {
      setFetchPVC(fetchPVC + 1);
    }
    if (isLoadedPVD) {
      setFetchPVD(fetchPVD + 1);
    }
    restartButton();
  };

  const thicknessHandler = (value) => {
    setThickness(value.value);
    if (isLoaded) {
      setFetch(fetch + 1);
    }
    if (isLoadedPVC) {
      setFetchPVC(fetchPVC + 1);
    }
    if (isLoadedPVD) {
      setFetchPVD(fetchPVD + 1);
    }
    restartButton();
  };

  //  _____________ PVC ______________
  const [isLoadedPVC, setIsLoadedPVC] = useState(false);
  const [fetchPVC, setFetchPVC] = useState(1);

  const mounted = useRef(false);
  useEffect(() => {
    if (!mounted.current) {
      // do componentDidMount logic
      mounted.current = true;
    } else {
      // do componentDidUpdate logic
      setIsLoaded(false);
      setIsLoadedPVC(false);
      setIsLoadedPVD(false);

      api.catalog
        .getTermoFilmPvcCalc({
          form_factor: formFactor,
          width: width,
          length: length,
          thickness: thickness,
        })
        .then((response) => {
          setItems(response);
          for (let item of response.form_factor) {
            if (item.is_active === true) {
              setDefaultFormFactor(item);
            }
          }
          for (let item of response.width) {
            if (item.is_active === true) {
              setDefaultWidth(item);
            }
          }
          for (let item of response.length) {
            if (item.is_active === true) {
              setDefaultLength(item);
            }
          }
          for (let item of response.thickness) {
            if (item.is_active === true) {
              setDefaultThickness(item);
            }
          }
          setIsLoadedPVC(true);
        });
    }
  }, [fetchPVC]);

  //  _____________ PVD ______________
  const [isLoadedPVD, setIsLoadedPVD] = useState(false);
  const [fetchPVD, setFetchPVD] = useState(1);

  const mountedPVD = useRef(false);
  useEffect(() => {
    if (!mountedPVD.current) {
      // do componentDidMount logic
      mountedPVD.current = true;
    } else {
      // do componentDidUpdate logic
      setIsLoaded(false);
      setIsLoadedPVC(false);
      setIsLoadedPVD(false);

      api.catalog
        .getTermoFilmPvdCalc({
          form_factor: formFactor,
          width: width,
          length: length,
          thickness: thickness,
        })
        .then((response) => {
          setItems(response);
          for (let item of response.form_factor) {
            if (item.is_active === true) {
              setDefaultFormFactor(item);
            }
          }
          for (let item of response.width) {
            if (item.is_active === true) {
              setDefaultWidth(item);
            }
          }
          for (let item of response.length) {
            if (item.is_active === true) {
              setDefaultLength(item);
            }
          }
          for (let item of response.thickness) {
            if (item.is_active === true) {
              setDefaultThickness(item);
            }
          }
          setIsLoadedPVD(true);
        });
    }
  }, [fetchPVD]);

  const radioHandler = (e) => {
    let radio1 = document.querySelector("#radio-1");
    let radio2 = document.querySelector("#radio-2");
    let radio3 = document.querySelector("#radio-3");

    if (e.target.id === "radio-1" && isLoaded === true) {
      return;
    } else if (e.target.id === "radio-2" && isLoadedPVC === true) {
      return;
    } else if (e.target.id === "radio-3" && isLoadedPVD === true) {
      return;
    }
    if (radio1.checked === true) {
      setFetch(fetch + 1);
      document.querySelector(".calc-right__title").innerHTML =
        "Плёнка термоусадочная ПОФ";
    } else if (radio2.checked === true) {
      setFetchPVC(fetchPVC + 1);
      document.querySelector(".calc-right__title").innerHTML =
        "Плёнка термоусадочная ПВХ";
    } else if (radio3.checked === true) {
      setFetchPVD(fetchPVD + 1);
      document.querySelector(".calc-right__title").innerHTML =
        "Плёнка термоусадочная ПВД";
    }
    restartButton();
  };

  const resetHandler = () => {
    document.querySelector("#radio-1").checked = true;
    setCount(1);
    setFormFactor(1);
    setThickness(1);
    setWidth(1);
    setLength(1);
    setFetch(fetch + 1);
    setIsAdd(false);
  };

  const restartButton = () => {
    setIsAdd(false);
  };

  const [isAdd, setIsAdd] = useState(false);
  const postItem = () => {
    setIsFetchedAdd(true);

    addCartItem({
      product_article: items.article,
      item_quantity: count,
      package_quantity: 0,
    })
    .then(() => {
      setIsFetchedAdd(false);
      setIsAdd(true);
    });
  };


  const [minPrice, setMinPrice] = useState();
  const [maxPrice, setMaxPrice] = useState();
  useEffect(() => {
    if (isLoaded) {
      setMinPrice(format_price(items.min_price));
      setMaxPrice(format_price(items.max_price));
    }
  }, [isLoaded]);

  useEffect(() => {
    if (isLoadedPVC) {
      setMinPrice(format_price(items.min_price));
      setMaxPrice(format_price(items.max_price));
    }
  }, [isLoadedPVC]);

  useEffect(() => {
    if (isLoadedPVD) {
      setMinPrice(format_price(items.min_price));
      setMaxPrice(format_price(items.max_price));
    }
  }, [isLoadedPVD]);

  let slideIndex = 1;
  function showSlides(slideIndex) {
    let sliderSize = document.querySelector(".how-gallery-slider").clientWidth;
    const slides = document.querySelectorAll(
      ".how-gallery-slider__slides-item"
    );
    for (let slide of slides) {
      slide.style.transform = `translateX(-${(slideIndex - 1) * sliderSize}px)`;
    }

    const dots = document.querySelectorAll(".controls-dots-dot");
    for (let dot of dots) {
      dot.classList.remove("controls-dots-dot-active");
    }
    dots[slideIndex - 1].classList.add("controls-dots-dot-active");
  }

  useEffect(() => {
      if (document.querySelectorAll(".controls-dots-dot").length !== 0) {
        const dots = document.querySelectorAll(".controls-dots-dot");
        if (dots.length === 1) {
          document.querySelector(
            ".how-gallery-slider__controls"
          ).style.display = "none";
        }
        dots[0].classList.add("controls-dots-dot-active");
        for (let i = 0; i < dots.length; i++) {
          const dot = dots[i];
          dot.addEventListener("click", () => {
            slideIndex = i + 1;
            showSlides(slideIndex);
          });
        }
        let backBtn = document.querySelector("#backBtn");
        backBtn.addEventListener("click", back);
        let frvBtn = document.querySelector("#frvBtn");
        frvBtn.addEventListener("click", frv);
      }
  }, []);

  const back = () => {
      const dots = document.querySelectorAll(".controls-dots-dot");
      if (slideIndex === 1) {
        slideIndex = dots.length;
      } else {
        slideIndex -= 1;
      }
      showSlides(slideIndex);
  };

  const frv = () => {
      const dots = document.querySelectorAll(".controls-dots-dot");
      if (slideIndex === dots.length) {
        slideIndex = 1;
      } else {
        slideIndex += 1;
      }
      showSlides(slideIndex);
  };

  return (
    <div className='calculator-main-content-calc'>
      <div className='calc-setings'>
        <div className='calc-settings-wrap'>
          <ul className='calc-settings__list'>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title radio-title'>Вид:</p>
              <div className='calc-settings__list-item-setting radio-settings-wrap'>
                {isLoaded || isLoadedPVC || isLoadedPVD ? (
                  <div className='radio-settings'>
                    <div className='form_radio'>
                      <input
                        id='radio-1'
                        type='radio'
                        name='radio'
                        value='1'
                        onClick={(e) => radioHandler(e)}
                        defaultChecked={isLoaded}
                      />
                      <label htmlFor='radio-1'>ПОФ</label>
                    </div>
                    <div className='form_radio'>
                      <input
                        id='radio-2'
                        type='radio'
                        name='radio'
                        value='1'
                        onClick={(e) => radioHandler(e)}
                        defaultChecked={isLoadedPVC}
                      />
                      <label htmlFor='radio-2'>ПВХ</label>
                    </div>
                    <div className='form_radio'>
                      <input
                        id='radio-3'
                        type='radio'
                        name='radio'
                        value='1'
                        onClick={(e) => radioHandler(e)}
                        defaultChecked={isLoadedPVD}
                      />
                      <label htmlFor='radio-3'>ПВД</label>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className='radio-loader' />
                    <div className='radio-loader' />
                    <div className='radio-loader' />
                  </>
                )}
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Форма сложения:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded || isLoadedPVC || isLoadedPVD ? (
                  <InputSelect
                    defaultValue={defaultFormFactor}
                    options={items.form_factor}
                    onchangeInput={formFactorHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Ширина, мм:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded || isLoadedPVC || isLoadedPVD ? (
                  <InputSelect
                    defaultValue={defaultWidth}
                    options={items.width}
                    onchangeInput={widthHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Толщина, мкм:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded || isLoadedPVC || isLoadedPVD ? (
                  <InputSelect
                    defaultValue={defaultThickness}
                    options={items.thickness}
                    onchangeInput={thicknessHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Длина, м:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded || isLoadedPVC || isLoadedPVD ? (
                  <InputSelect
                    defaultValue={defaultLength}
                    options={items.length}
                    onchangeInput={lengthHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            {isLoaded || isLoadedPVC || isLoadedPVD ? (
              <li className='calc-settings__list-item'>
                <p className='calc-settings__list-item-title'>
                  {items.page_data.count_text !== ""
                    ? items.page_data.count_text
                    : "Количество, шт:"}
                </p>
                <Counter2
                  id={"counter1"}
                  onChange={setCount}
                  count={count}
                  minCount={items.multiplicity}
                  step={items.multiplicity}
                  multiplicity={items.multiplicity}
                  restart={restartButton}
                />
              </li>
            ) : null}
            <li className='calc-settings__list-item mobile-list-item'>
              <p className='calc-settings__list-item-title'>Наличие:</p>
              {items.in_stock == "в наличии" ||
              items.in_stock == "В наличии" ? (
                <div className='calc-settings__list-item-setting settings-stock'>
                  {items.in_stock}
                </div>
              ) : (
                <div className='calc-settings__list-item-setting settings-outOfStock'>
                  {items.in_stock}
                </div>
              )}
            </li>
            <Price minPrice={minPrice} maxPrice={maxPrice} />

            <li className='calc-settings__list-item calc-border'>
              <div className='calc-settings-border'></div>
            </li>
            <li className='calc-settings__list-item calc-cart'>
              <button
                className='calc-settings__button-reset'
                onClick={resetHandler}
              >
                <div className='button-reset-icon'></div>
                <div className='button-reset-title'>Сбросить</div>
              </button>
              <AddOrLinkButton
                isAdd={isAdd}
                postItem={postItem}
                isFetchedAdd={isFetchedAdd}
              />
            </li>
          </ul>
        </div>
      </div>
      <div className='calc-right'>
        <div className='calc-right__content'>
          {items.image ? (
            <div className='calc-right__img'>
              <img loading="lazy" src={PICS_URL + items.image} alt={items.title || ''} />
            </div>
          ) : null}
          <h3 className='calc-right__title'>Плёнка термоусадочная ПОФ</h3>
          <table className='calc-right__table'>
            <tbody>
              <tr>
                <th>Артикул</th>
                <td>{items.article}</td>
              </tr>
              <tr>
                <th>Техническое название</th>
                <td>{items.title}</td>
              </tr>
              {items.net_weight ? (
                <tr>
                  {isLoadedPVD ? (
                    <th>Вес нетто ролика, кг</th>
                  ) : (
                    <th>Вес нетто рулона, кг</th>
                  )}
                  <td>{items.net_weight}</td>
                </tr>
              ) : null}
              {items.min_order
                ? (
                    <tr>
                      <th>Вес ролика</th>
                      <td>{items.net_weight}</td>
                    </tr>
                  ) && (
                    <tr>
                      <th>Минимальное количество заказа</th>
                      <td>{items.min_order}</td>
                    </tr>
                  )
                : null}
            </tbody>
          </table>
          {items?.page_data?.pak_pakych_quote ? (
            <CalculatorPackichQuote
              text={items.page_data.pak_pakych_quote.text}
              bgColor={items.page_data.pak_pakych_quote.bg_color}
              borderColor={items.page_data.pak_pakych_quote.border_color}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Termofilm;
